import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Alert } from '@mui/joy';
import { SimplifiedSigningInterface } from './contracts/SimplifiedSigningInterface';

export const ContractSigningPage: React.FC = () => {
  const { contractId, sessionToken } = useParams<{
    contractId: string;
    sessionToken: string;
  }>();

  if (!contractId || !sessionToken) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert color="danger">
          Invalid signing link. Please check the URL and try again.
        </Alert>
      </Box>
    );
  }

  return (
    <SimplifiedSigningInterface
      contractId={parseInt(contractId)}
      signingToken={sessionToken}
    />
  );
};